import React from "react";
import Glimmer from "@components/Glimmer";

const style = {marginTop: 5, marginBottom: 5} as const;
const LocationNameLoading = () => {
  return <Glimmer height={52} width={310} style={style} />;
};

export default React.memo(LocationNameLoading);
